<ng-container>
  <div class="mx-5 my-4 surplus-license-details-container">
    <form [formGroup]="companyDetailForm">
      <div class="px-2 mt-5">
        <!-- <div class="d-flex justify-content-between align-items-center mb-6 header-row">
          <h4 class="fw-bold text-gray-900 mb-0">Contact Person Details</h4>
          <h4 class="fw-bold text-gray-900 mb-0">Surplus Lines License Details</h4>
        </div> -->

        <div class="row mb-5 align-items-end">
          <div class="col-12 col-md-6 form-container mb-6">
            <label
              class="form-label form-label-floating mb-3 required"
              [ngClass]="{'border-danger': companyDetailForm.get('slaNumber')?.invalid && companyDetailForm.get('slaNumber')?.touched}"
            >
              SLA Number
            </label>
            <input
              type="text"
              class="form-control form-control-lg form-control-solid"
              formControlName="slaNumber"
              name="slaNumber"
              placeholder=""
              [ngClass]="{'border-danger': companyDetailForm.get('slaNumber')?.invalid && companyDetailForm.get('slaNumber')?.touched}"
            />
            @if (companyDetailForm.get('slaNumber')?.invalid && companyDetailForm.get('slaNumber')?.touched) {
              <span class="text-danger">
                @if (companyDetailForm.get('slaNumber')?.errors?.['required']) {
                  SLA Number is required.
                } @else if (companyDetailForm.get('slaNumber')?.errors?.['pattern']) {
                  SLA Number must be 5 alphanumeric characters.
                }
              </span>
            }
          </div>

          <div class="col-12 col-md-3 mb-6 d-flex align-items-center">
            <button
              type="button"
              class="btn btn-lg btn-primary ms-md-3 w-100 w-md-auto"
              [disabled]="
                !companyDetailForm.get('slaNumber')?.value?.trim() ||
                companyDetailForm.get('slaNumber')?.invalid
              "
              (click)="addProducerSlaNumber()"
            >
              Add
            </button>
          </div>
        </div>

        <div class="row mb-5">
          <div class="col-12">
            <table
              mat-table
              [dataSource]="producerSlaDataSource"
              class="border border-2 border-secondary rounded bg-transparent w-100"
            >
              <ng-container matColumnDef="#">
                <th class="fs-7 fw-bold" mat-header-cell *matHeaderCellDef> # </th>
                <td class="fs-7" mat-cell *matCellDef="let element; let i = index;"> {{ i + 1 }} </td>
              </ng-container>

              <ng-container matColumnDef="slaNumber">
                <th class="fs-7 fw-bold" mat-header-cell *matHeaderCellDef> Producer SLA Number </th>
                <td class="fs-7" mat-cell *matCellDef="let element"> {{ element.value }} </td>
              </ng-container>

              <ng-container matColumnDef="action">
                <th class="fs-7 fw-bold" mat-header-cell *matHeaderCellDef> </th>
                <td class="fs-7" mat-cell *matCellDef="let element; let i = index;">
                  <button
                    (click)="removeProducerSlaNumber(i)"
                    mat-button
                    type="button"
                    class="btn"
                    aria-label="Remove producer SLA number"
                  >
                    <i class="bi bi-x fs-3 fw-bold border border-1 border-dark-subtle p-2 rounded"></i>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

            @if (producerSlaNumbers.length === 0) {
              <div class="text-center my-2">
                No records found
              </div>
            }
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-container>


